<template>
  <div class="relative">
    <a 
      class="cursor-pointer inline-flex items-center justify-center gap-2 px-6 py-3 bg-white text-[#2E6DD1] border-2 border-[#2E6DD1] hover:bg-[#f8f8f8] font-['Poppins'] font-semibold rounded-full transition-colors duration-300 uppercase"
      @click="onClick($event)"
    >
      <img 
        v-if="showIcon" 
        loading="lazy" 
        alt="Ícone do WhatsApp" 
        :src="require('@/assets/img/home/help/whatsapp-blue.svg')"
        class="w-6 h-6"
      />
      <span class="whitespace-nowrap">FALAR COM ESPECIALISTA</span>
    </a>

    <!-- Overlay com blur e Formulário -->
    <div v-if="isFormActive" 
      class="fixed inset-0 z-50 backdrop-blur-sm bg-black bg-opacity-60 transition-all duration-300"
      @click="closeForm"
    >
      <div 
        class="h-full md:h-auto w-full md:max-w-[500px] mx-auto flex flex-col md:mt-[10vh]"
        @click.stop
      >
        <WhatsAppForm @close="closeForm" />
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { useWhatsAppFormManager } from "@/composables/useWhatsAppFormManager";
import WhatsAppForm from "@/components/WhatsAppForm.vue";

export default {
  name: "WhatsAppButton",
  components: {
    WhatsAppForm
  },
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    variant: {
      type: String,
      default: 'icon',
    }
  },
  setup(props) {
    const formManager = useWhatsAppFormManager();

    const toggleChat = (event) => {
      // Previne propagar o evento para o documento
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      
      if (formManager.isFormActive(props.variant)) {
        formManager.closeForm();
      } else {
        formManager.openForm(props.variant);
      }
    };

    const isFormActive = computed(() => formManager.isFormActive(props.variant));

    return {
      onClick: toggleChat,
      isFormActive,
      closeForm: formManager.closeForm
    };
  }
};
</script>
